import {useTranslation} from "react-i18next";

import {useEffect, useRef, useState} from "react";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import NavBreadcrum from "components/NavBreadcrum";
import axiApi from "ApiCaller";
import TableShipping from "./shipping/TableShipping";
import FilterShipping from "./shipping/FilterShipping";
import FormShipping from "./shipping/FormShipping";
import {DeviceShipping} from "site-apps/devices/DeviceShipping";
import navs from "./navs";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";
import useCustomTranslation from "core/customTranslation";
import translations from "./shipping/translations";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import OrderingModel from "components/ordering/OrderingModel";

const buttonsActions = {
    title: "",
    edit: {
        active: true,
        disabled: true,
        onClick: () => {},
    },
    send: {
        active: true,
        disabled: true,
        onClick: () => {},
    },
};
const FiltersDefaults = {
    models: [],
    configs: [],
    device_groups: [],
    asset_groups: [],
    islands: [],
    routes: [],
};
const ViewShipping = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tc} = useCustomTranslation(translations);
    const title = _Tr("labels.send");
    const bread = [
        {
            name: _Tr("labels.device-configuration"),
            url: "/device-configuration/",
            current: false,
        },
        {name: title, current: true},
    ];
    const Alert = new SwalAlertClass({confirmButtonText: _Tc("button.accept")});
    const Question = new SwalAlertChoice({
        confirmButtonText: _Tc("button.accept"),
        cancelButtonText: _Tc("button.cancel"),
    });

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [item, setItem] = useState({...DeviceShipping});
    const [checkedAll, setCheckedAll] = useState(false);
    const [params, setParams] = useState(FiltersDefaults);
    const [buttonsTB, setButtonsTB] = useState(buttonsActions);
    const [isLoading, setIsLoading] = useState(false);
    // data table
    const [itemsShown, setItemsShown] = useState([]);
    const [showCanvas, setShowCanvas] = useState(false);
    const [showPrev, setShowPrev] = useState(false);

    const headersTable = [
        {
            name: (
                <>
                    {_Tc("table.header.uuid")}
                    <br />
                    {_Tc("table.header.model")}
                </>
            ),
            attr: 0,
            direction: "asc",
            active: true,
            default: true,
        },
    ];

    useEffect(() => {
        let buttons = {...buttonsTB};
        document.title = title;
        buttons.title = title;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;
        buttons.send.disabled = true;
        buttons.send.onClick = onClickSend;
        setButtonsTB(buttons);
        // -
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchPostData();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => {
            fetchPostData();
        };
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = DeviceShipping;
        subscribeEvent("reload:view:shippings", updateShippings);
        fetchGetdata();
        return () => {
            unsubscribeEvent("reload:view:shippings", updateShippings);
        };
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        fetchPostData();
    };

    const updateShippings = () => {
        fetchPostData();
    };

    const onClickEdit = (e) => {
        setShowCanvas(true);
    };

    const fetchGetdata = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.get("/api/devices/shippings/", filters.current.chosen, {
                params: pagerModelRef.current.paging.getParams(),
            });

            if (resp.data) {
                items.current.showed = [...resp.data.items];
                setItemsShown([...resp.data.items]);
                setParams({...resp.data.params});
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
        }
        setIsLoading(false);
    };

    const fetchPostData = async (filtersToApply) => {
        setIsLoading(true);
        try {
            const resp = await axiApi.post("/api/devices/shippings/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            });

            if (resp.data) {
                items.current.setShowed(resp.data.items);
                setItemsShown([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
        }
        setIsLoading(false);
    };
    const onClickSend = (e) => {
        Question.info("Se enviara", `La configuracion actual a ${items.current.chosen.length} dispositivos.`).then((resp) => {
            if (resp.isConfirmed) {
                let itemsSelected = [];
                itemsSelected = items.current.getChosenUuids();
                axiApi
                    .post("/api/devices/re-shipping/", {chosen: itemsSelected})
                    .then((r) => {
                        if (r.data.status) {
                            fetchPostData();
                            Alert.success("Solicitud", "Se han encolado las configuraciones para su envio.");
                        } else {
                            Alert.error("Error en el servicio", "Avise al administrador.");
                        }
                    })
                    .catch((error) => {
                        console.error("[FormShipping] Error al guardar la configuración");
                        console.error(error);
                        if (error.response.status === 400 || error.response.status === 404) {
                            Alert.error("Error en el servidor", "Los datos enviados no son correctos.");
                        } else {
                            Alert.error("Error en el servidor", "Consultar con el administrador.");
                        }
                    });
            }
        });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <FilterShipping params={params} items={items} actions={buttonsTB} filters={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="142px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableShipping
                            items={items}
                            itemsShow={itemsShown}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            setItem={setItem}
                            checkAll={checkedAll}
                            setCheckAll={setCheckedAll}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
            </div>
            {showCanvas ? (
                <FormShipping
                    item={item}
                    items={items}
                    showCanvas={showCanvas}
                    setShowCanvas={setShowCanvas}
                    setItemsShown={setItemsShown}
                />
            ) : (
                <></>
            )}
        </>
    );
};
export default ViewShipping;